// @flow
import * as React from 'react';
import CookieConstants from 'constants/CookieConstants';
import Cookies from 'lib/Cookies';
import Modal from 'react-modal';
import { graphql } from 'react-apollo';
import idx from 'idx';

import LimitedClassesModal from './LimitedClassesModal';
import LIMITED_CLASSES_QUERY from './queries/LimitedClassesQuery.gql';

import type { LimitedClasses } from './queries/__generated__/LimitedClasses';

export type Props = {
  data: ReactApolloData<LimitedClasses>,
};

type State = {
  modalIsOpen: boolean,
};

class LimitedClassesModalContainer extends React.Component<Props, State> {
  state = {
    modalIsOpen: !Cookies.get(CookieConstants.HAS_SEEN_LIMITED_CLASSES_MODAL),
  };

  hideModalForever = () => {
    if (!Cookies.get(CookieConstants.HAS_SEEN_LIMITED_CLASSES_MODAL)) {
      Cookies.set(CookieConstants.HAS_SEEN_LIMITED_CLASSES_MODAL, true);
    }
    this.setState({ modalIsOpen: false });
  };

  render() {
    const { data } = this.props;
    const limitedClasses = idx(data, _ => _.productLimits.limitedClasses);
    if (!limitedClasses || limitedClasses.length === 0) {
      return null;
    }
    return (
      <Modal isOpen={this.state.modalIsOpen} data-test="limited-classes-modal-container">
        <LimitedClassesModal
          limitedClassNames={limitedClasses}
          onRequestHide={this.hideModalForever}
        />
      </Modal>
    );
  }
}

const withLimitedClasses = graphql(LIMITED_CLASSES_QUERY, {
  skip: () => Cookies.get(CookieConstants.HAS_SEEN_LIMITED_CLASSES_MODAL),
});

export { LimitedClassesModalContainer };

export default withLimitedClasses(LimitedClassesModalContainer);
